import { UntypedFormGroup } from "@angular/forms";
import { CurrentSupplier, ISupplierDTO, IUpdateFromCompanyInfoPage, IUpdateProp65Info } from "../account/current-supplier.interface";
import { CurrentUser } from "../account/current-user.interface";
import { InvitationDetails } from "../account/register.interface";

export class ModelsMapper {
	static mapValidateRegistrationRequest(formValue, invitationDetails: InvitationDetails) {
		return {
			username: formValue.username,
			password: formValue.password,
			firstName: formValue.firstName,
			lastName: formValue.lastName,
			phone: formValue.phone,
			email: invitationDetails.email,
			role: invitationDetails.role,
			supplierId: invitationDetails.supplierId,
		};
	}

	static mapUpdateProp65Contact(formValue): IUpdateProp65Info {
		return {
			prop65ContactName: formValue.prop65ContactName.value,
			prop65ContactTitle: formValue.prop65ContactTitle.value,
			prop65ContactPhone: formValue.prop65ContactPhone.value,
		};
	}

	static mapUpdateCompanyInfoPageData(formValue, supplierId: string): IUpdateFromCompanyInfoPage {
		return {
			supplierId: supplierId,
			supplierName: formValue.companyName.value,
			supplierAddress1: formValue.address1.value,
			supplierAddress2: formValue.address2.value,
			supplierCity: formValue.city.value,
			supplierFax: formValue.companyFax.value,
			supplierPhone: formValue.companyPhone.value,
			supplierState: formValue.state.value.code,
			supplierZip: formValue.zip.value,
			supplierCountry: formValue.state.value.countryCode,
			websiteURL: formValue.website.value,
			primaryContactName: formValue.primaryContactName.value,
			primaryContactTitle: formValue.primaryContactTitle.value,
			primaryContactPhone: formValue.primaryContactPhone.value,
			prop65ContactName: formValue.prop65ContactName.value,
			prop65ContactPhone: formValue.prop65ContactPhone.value,
			prop65ContactTitle: formValue.prop65ContactTitle.value,
		};
	}

	static mapSupplierClassToInterface(currentSupplier: CurrentSupplier): ISupplierDTO {
		return {
			supplierId: currentSupplier.supplierId,
			supplierName: currentSupplier.supplierName,
			supplierAddress1: currentSupplier.supplierLocation.supplierAddress1,
			supplierAddress2: currentSupplier.supplierLocation.supplierAddress2,
			supplierCity: currentSupplier.supplierLocation.supplierCity,
			supplierState: currentSupplier.supplierLocation.supplierState,
			supplierCountry: currentSupplier.supplierLocation.supplierCountry,
			supplierZip: currentSupplier.supplierLocation.supplierZip,
			supplierPhone: currentSupplier.supplierLocation.supplierPhone,
			supplierFax: currentSupplier.supplierLocation.supplierFax,
			primaryContactName: currentSupplier.primaryContact.primaryContactName,
			primaryContactTitle: currentSupplier.primaryContact.primaryContactTitle,
			primaryContactEmail: currentSupplier.primaryContact.primaryContactEmail,
			primaryContactPhone: currentSupplier.primaryContact.primaryContactPhone,
			prop65ContactName: currentSupplier.prop65Contact.prop65ContactName,
			prop65ContactTitle: currentSupplier.prop65Contact.prop65ContactTitle,
			prop65ContactEmail: currentSupplier.prop65Contact.prop65ContactEmail,
			prop65ContactPhone: currentSupplier.prop65Contact.prop65ContactPhone,
			websiteURL: currentSupplier.websiteURL,
			allowSellInCalifornia: currentSupplier.displayPreferences.allowSellInCalifornia,
			allowNoOnProductWarning: currentSupplier.displayPreferences.allowNoOnProductWarning,
			allowUseShortWarning: currentSupplier.displayPreferences.allowUseShortWarning,
			primaryUsername: currentSupplier.primaryContact.primaryUsername,
			prop65Username: currentSupplier.prop65Contact.prop65Username,
			updatedBy: currentSupplier.updatedBy,
			updated: currentSupplier.updated,
			hasItems: currentSupplier.hasItems,
		};
	}

	static mapAccountDataFormToCurrentSupplier(formGroup: UntypedFormGroup, currentUser: CurrentUser, currentSupplier: CurrentSupplier): ISupplierDTO {
		const formControls = formGroup.controls;
		return {
			supplierId: currentUser.supplierId,
			supplierName: formControls.companyName.value,
			websiteURL: formControls.website.value,
			supplierAddress1: formControls.address1.value,
			supplierAddress2: formControls.address2.value,
			supplierCity: formControls.city.value,
			supplierState: formControls.state.value.code,
			supplierCountry: formControls.state.value.countryCode,
			supplierZip: formControls.zip.value,
			supplierPhone: formControls.companyPhone.value?.toString(),
			supplierFax: formControls.companyFax.value,
			primaryContactName: formControls.primaryContactName.value,
			primaryContactTitle: formControls.primaryContactTitle.value,
			primaryContactEmail: formControls.primaryContactEmail.value,
			primaryContactPhone: formControls.primaryContactPhone.value?.toString(),
			prop65ContactName: formControls.complianceSameAsPrimary.value
				? null
				: formControls.prop65ContactName.value.length > 0
					? formControls.prop65ContactName.value
					: null,
			prop65ContactTitle: formControls.complianceSameAsPrimary.value
				? null
				: formControls.prop65ContactTitle.value.length > 0
					? formControls.prop65ContactTitle.value
					: null,
			prop65ContactEmail: null,
			prop65ContactPhone: formControls.complianceSameAsPrimary.value ? null : formControls.prop65ContactPhone.value,
			primaryUsername: formControls.primaryUsername.value,
			prop65Username: formControls.complianceSameAsPrimary.value ? formControls.primaryUsername.value : formControls.prop65Username.value,
			hasItems: currentSupplier?.hasItems,
		};
	}
}
